import React, { memo } from 'react'

import { PRIVATE_MODE_TOOLTIP_MESSAGE } from 'Pods/ThreeDStudio/constants'
import usePrivateModeAccess from 'Pods/ThreeDStudio/Hooks/usePrivateModeAccess'
import SubscribersOnlyHover from 'Pods/ThreeDStudio/Shared/SubscribersOnlyHover/SubscribersOnlyHover'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { setIsPrivate } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

function PrivateModeSelector() {
  const hasPrivateModeAccess = usePrivateModeAccess()

  const selector = (
    <ToggleSelector
      id="private-mode-selector"
      keyName="isPrivate"
      sliceName="modelSettings"
      label="Private Mode"
      setFunction={setIsPrivate}
      tooltipMessage={PRIVATE_MODE_TOOLTIP_MESSAGE}
      disabled={!hasPrivateModeAccess}
    />
  )

  if (hasPrivateModeAccess) {
    return selector
  }

  return (
    <SubscribersOnlyHover id="private-mode-upsell" placement="top">
      {selector}
    </SubscribersOnlyHover>
  )
}

export default memo(PrivateModeSelector)
